// Global
import React from 'react';
// Local
import { Content } from '@generated/Content/PullQuote.model';
import { PullQuote } from './PullQuote';
import { usePlainTextWrapper } from 'components/helpers/SitecoreWrappers/PlainTextWrapper/PlainTextWrapper';
import { Themes } from 'lib/themes';

type PullQuoteProps = Content.PullQuote.PullQuote_Component;

export const Default = (props: PullQuoteProps) => {
  /*
   * Rendering
   */

  const quotation = usePlainTextWrapper({ field: props.fields?.quotation });
  const name = usePlainTextWrapper({ field: props.fields?.name });
  const title = usePlainTextWrapper({ field: props.fields?.title });

  if (!props.fields) {
    return <></>;
  }

  return (
    <PullQuote
      quotation={quotation}
      name={name}
      title={title}
      theme={props.params?.theme as Themes}
    />
  );
};
